import * as React from "react"; // tslint:disable-line
import styled, { css } from "styled-components";

import { mainWidth, media, space } from "./common";

export interface PanelProps {
  space?: number;
}
export const Panel = styled.div<PanelProps>`
  margin: ${(props) => 2 * (props.space || space)}px;
`;

export const PhoneShow = styled.div`
  ${media.sm`
    display: none !important;
  `};
`;

export const MobileShow = styled.div`
  ${media.md`
    display: none !important;
  `};
`;

export const DesktopShow = styled.div`
  display: none;
  ${media.md`
    display: block;
  `};
`;

export const ContentBoxStyles = css<PanelProps>`
  height: 100%;
  ${(props) => {
    const gutter = props.space !== undefined ? props.space : space;
    return css`
      margin: 0 ${2 * gutter}px ${2 * gutter}px;
    `;
  }}
  ${media.sm`
    margin: 0 ${3 * space}px ${2 * space}px;
  `}
  ${(props) => media.md`
    margin: ${2 * (props.space !== undefined ? props.space : space)}px ${
    3 * space
  }px;
  `}
  ${(props) =>
    media.lg`
      margin: ${2 * (props.space !== undefined ? props.space : space)}px auto;
      max-width: ${mainWidth}px;
    `};
`;

export const ContentBox = styled.section<PanelProps>`
  ${ContentBoxStyles}
`;
